import React from "react";

import './footer.css';
import { Separator } from "../components/separator";

export const Footer = () => {
  return (
    <div class='footer'>
      <Separator />
      <div className='footer_inner'>
        <p className="copyright">Copyright (c) 2024 Rasoi Dining Club. All Rights Reserved.</p>
      </div>
    </div>
  )
}
